/**
 * Init wind-blowing animation for flourishes SVG paths
 */
function initFlourishesAnimation( node, gsap ) {
	const svg = node.querySelector( 'svg' );
	if ( ! svg ) {
		return;
	}

	const containers = svg.querySelectorAll( 'g.flourish-container' );
	if ( ! containers || containers.length === 0 ) {
		return;
	}

	// Get SVG width to calculate proper loop distance
	const svgWidth = svg.viewBox.baseVal.width || 1800;
	const loopDistance = svgWidth * 2;

	// Animation constants
	const DURATION_BASE = 25;
	const DURATION_VARIANCE = 15;
	const ROTATION_BASE = 35;
	const ROTATION_VARIANCE = 25;
	const ROTATION_DURATION_BASE = 2;
	const ROTATION_DURATION_VARIANCE = 2;
	const WAVE_AMPLITUDE_BASE = 50;
	const WAVE_AMPLITUDE_VARIANCE = 30;
	const WAVES_PER_CYCLE = 2;

	// Intro animation
	gsap.set( svg, {
		opacity: 0,
	} );

	gsap.to( svg, {
		duration: 2,
		ease: 'power2.inOut',
		opacity: 1,
	} );

	// Animate each container with continuous left-to-right flow
	containers.forEach( ( container, index ) => {
		const paths = container.querySelectorAll( 'path' );
		if ( ! paths.length ) {
			return;
		}

		const path = paths[0];

		// Calculate random variations for more natural wind effect
		const duration = DURATION_BASE + Math.random() * DURATION_VARIANCE;
		const rotation = ROTATION_BASE + Math.random() * ROTATION_VARIANCE;
		const rotationDuration = ROTATION_DURATION_BASE + Math.random() * ROTATION_DURATION_VARIANCE;

		// Get bounding box for SVG path to find center point for rotation
		const bbox = path.getBBox();
		const centerX = bbox.x + bbox.width / 2;
		const centerY = bbox.y + bbox.height / 2;

		// Distribute containers across the FULL loop distance for seamless flow
		const startX = -loopDistance * 0.5;
		const endX = startX + loopDistance;

		// Distribute containers across the FULL cycle (0 to 1) for continuous coverage
		const initialProgress = index / containers.length;
		const initialX = startX + loopDistance * initialProgress;

		// Wave motion parameters (down, up, down pattern)
		const waveAmplitude = WAVE_AMPLITUDE_BASE + Math.random() * WAVE_AMPLITUDE_VARIANCE;
		const waveOffset = ( index / containers.length ) * Math.PI * 2;

		// Create quickSetter for efficient y updates (avoids creating new tweens each frame)
		const setY = gsap.quickSetter( container, 'y', 'px' );

		// Helper to calculate wave Y position
		const calculateWaveY = ( progress ) => Math.sin( progress * Math.PI * 2 * WAVES_PER_CYCLE + waveOffset ) * waveAmplitude;

		// Set initial position with wave offset
		gsap.set( container, {
			x: initialX,
			y: calculateWaveY( initialProgress ),
		} );

		// Set rotation origin for path
		gsap.set( path, {
			svgOrigin: `${ centerX } ${ centerY }`,
		} );

		// Animate container from current position to end, then loop
		const animateContainer = ( fromX, fromProgress ) => {
			const distance = endX - fromX;
			const progressRange = 1 - fromProgress;
			const animDuration = ( distance / loopDistance ) * duration;

			gsap.to( container, {
				x: endX,
				duration: animDuration,
				ease: 'none',
				onUpdate: function () {
					// Calculate current progress (0 to 1) based on timeline progress
					const progress = this.progress();
					const totalProgress = fromProgress + progressRange * progress;
					// Calculate y using sine wave: down, up, down pattern
					setY( calculateWaveY( totalProgress ) );
				},
				onComplete: () => {
					// Container is now off-screen to the right, reset to off-screen left
					gsap.set( container, {
						x: startX,
						y: calculateWaveY( 0 ),
						immediateRender: false,
					} );
					// Resume animation from the start
					animateContainer( startX, 0 );
				},
			} );
		};

		// Start the animation
		animateContainer( initialX, initialProgress );

		// Continuous rotation wiggle on the <path> element
		gsap.to( path, {
			rotation: paths.length > 1 ? rotation * .4 : rotation,
			svgOrigin: `${ centerX } ${ centerY }`,
			duration: rotationDuration,
			ease: 'sine.inOut',
			repeat: -1,
			yoyo: true,
		} );
	} );
}

/**
 * Init function
 */
function init( node ) {
	if ( ! ( node instanceof HTMLElement ) ) {
		return;
	}

	// Validate GSAP availability
	const { gsap } = window;
	if ( ! gsap ) {
		console.warn( 'GSAP not available. Make sure gsap is enqueued.' );
		return;
	}

	initFlourishesAnimation( node, gsap );
}

/**
 * Initialize flourishes blocks when DOM is ready
 * Deferred scripts execute after DOMContentLoaded
 */
const initFlourishes = () => {
	document.querySelectorAll( '.flourishes' ).forEach( init );
};

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initFlourishes );
} else {
	initFlourishes();
}
